import QRCode from "qrcode";

// Generate a QR data URL with a centered logo and circular backdrop
export async function generateQrWithLogo(payload, logoSrc, options = {}) {
  const {
    size = 600,
    margin = 3,
    errorCorrectionLevel = "H",
    dark = "#000000",
    light = "#ffffff",
    diameterRatio = 0.34, // circle diameter as ratio of size
    innerPadRatio = 0.18, // padding between circle and logo
    borderColor = "#e6e6e6",
    shadow = true,
  } = options;

  const qrCanvas = document.createElement("canvas");
  await QRCode.toCanvas(qrCanvas, JSON.stringify(payload), {
    width: size,
    margin,
    errorCorrectionLevel,
    color: { dark, light },
  });

  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(qrCanvas, 0, 0);

  // load logo
  const logo = new Image();
  logo.src = logoSrc;
  await new Promise((resolve, reject) => {
    logo.onload = resolve;
    logo.onerror = reject;
  });

  // circle backdrop
  const diameter = size * diameterRatio;
  const radius = diameter / 2;
  const cx = size / 2;
  const cy = size / 2;

  ctx.save();
  ctx.beginPath();
  ctx.arc(cx, cy, radius, 0, Math.PI * 2);
  ctx.closePath();
  ctx.fillStyle = "#ffffff"; // fully opaque to block QR behind
  if (shadow) {
    ctx.shadowColor = "rgba(0,0,0,0.08)";
    ctx.shadowBlur = 8;
  }
  ctx.fill();
  ctx.shadowBlur = 0;
  if (borderColor) {
    ctx.lineWidth = 2;
    ctx.strokeStyle = borderColor;
    ctx.stroke();
  }
  ctx.restore();

  // logo with padding, preserve aspect ratio
  const innerPad = diameter * innerPadRatio;
  const maxW = diameter - innerPad * 2;
  const maxH = diameter - innerPad * 2;
  const aspect = (logo.width || 1) / (logo.height || 1);
  let drawW, drawH;
  if (maxW / maxH > aspect) {
    drawH = maxH;
    drawW = drawH * aspect;
  } else {
    drawW = maxW;
    drawH = drawW / aspect;
  }
  ctx.drawImage(logo, cx - drawW / 2, cy - drawH / 2, drawW, drawH);

  return canvas.toDataURL("image/png");
}
